/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

// Misc imports
import { setFooterContent } from '../store/global/globalActions';

/**
 * Adds content to the footer
 */
const FooterContent = ({ content }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFooterContent(content));

    return () => {
      // Cleanup
      dispatch(setFooterContent(null));
    };
  }, [content]);

  return null;
};

FooterContent.propTypes = {
  content: PropTypes.node
};

export default FooterContent;
